import { render } from "./SubsidiesMatrix.vue?vue&type=template&id=4f59eb5d&scoped=true"
import script from "./SubsidiesMatrix.vue?vue&type=script&lang=js"
export * from "./SubsidiesMatrix.vue?vue&type=script&lang=js"

import "./SubsidiesMatrix.vue?vue&type=style&index=0&id=4f59eb5d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f59eb5d"]])

export default __exports__